"use client";
import "../../chunk-MMUBH76A.js";
const brandedOAuthLogos = {
  GOOGLE: "googleBrand",
  TWITTER: "twitter",
  APPLE: "apple",
  DISCORD: "discordBrand",
  FACEBOOK: "facebookBrand",
  FARCASTER: "farcasterBrand",
  TELEGRAM: "telegramBrand"
};
const oAuthLogos = {
  GOOGLE: "google",
  TWITTER: "twitter",
  APPLE: "apple",
  DISCORD: "discord",
  FACEBOOK: "facebook",
  FARCASTER: "farcaster",
  TELEGRAM: "telegram"
};
export {
  brandedOAuthLogos,
  oAuthLogos
};
